var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 8,
    fill: "#F0F9FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 127,
    height: 127,
    rx: 7.5,
    stroke: "#1B3E61",
    strokeOpacity: 0.2,
    strokeDasharray: "4 3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5167_868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78 55.6H69.6V38.8H58.4V55.6H50L64 69.6L78 55.6ZM90.1464 73.8896C89.5584 73.2624 85.6356 69.0652 84.5156 67.9704C83.7308 67.2181 82.6852 66.7987 81.598 66.8H76.6784L85.2576 75.1833H75.3344C75.1995 75.1808 75.0664 75.2139 74.9484 75.2793C74.8304 75.3447 74.7318 75.44 74.6624 75.5556L72.3776 80.8H55.6224L53.3376 75.5556C53.2678 75.4404 53.169 75.3453 53.0512 75.28C52.9333 75.2147 52.8004 75.1813 52.6656 75.1833H42.7424L51.3188 66.8H46.402C45.2904 66.8 44.2292 67.2452 43.4844 67.9704C42.3644 69.068 38.4416 73.2652 37.8536 73.8896C36.4844 75.3484 35.7312 76.5104 36.0896 77.9468L37.6604 86.5541C38.0188 87.9932 39.5952 89.1748 41.166 89.1748H86.8396C88.4104 89.1748 89.9868 87.9932 90.3452 86.5541L91.916 77.9468C92.2688 76.5104 91.5184 75.3484 90.1464 73.8896Z",
    fill: "#1B3E61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5167_868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(36 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAttachmentIcon);
export default __webpack_public_path__ + "static/media/downloadAttachmentIcon.03b47e399680c8a7fa36d0d977403f3e.svg";
export { ForwardRef as ReactComponent };